import { GivelifyLabel, GivelifyTable } from '@givelify/givelify-ui';
import { Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

interface StyledProps {
    isGreyedOut?: boolean;
}

export const UserTable = styled(GivelifyTable)({
    background: '#FFFFFF',
    minWidth: 500,
    borderRadius: '10px',
}) as typeof GivelifyTable;

export const FaithLeaderTableContent = styled('div')({
    marginBottom: 24,
});

export const UsernameContainer = styled('div')({
    width: '100%',
    display: 'flex',
    cursor: 'pointer',
});

export const UserAvatarWrapper = styled('div')({
    width: 32,
    marginRight: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});

export const UserAvatarGrey = styled('div', {
    shouldForwardProp: (props) => props !== 'isGreyedOut',
})<StyledProps>(({ isGreyedOut }) => ({
    opacity: isGreyedOut ? 0.5 : 1,
}));

export const UserNameContent = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginRight: 'auto',
});

export const UserFullName = styled('div')({
    display: 'flex',
    '@media (max-width: 1050px)': {
        flexDirection: 'column',
    },
});

export const Title = styled(GivelifyLabel, {
    shouldForwardProp: (props) => props !== 'isGreyedOut',
})<StyledProps>(({ theme, isGreyedOut }) => ({
    lineHeight: '14px',
    color: isGreyedOut
        ? theme.legacy.colors.neutralGrey75
        : theme.legacy.colors.neutralGrey,
}));

export const NameHeader = styled('div')({
    display: 'flex',
    alignItems: 'center',
});

export const HeaderIcon = styled('div')({
    display: 'flex',
    alignItems: 'center',
    marginLeft: 11,
});

export const MoreAction = styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginRight: 8,
});

export const AccountOwnerBox = styled('div')({
    display: 'flex',
    alignItems: 'center',
    background: '#DFE1E5',
    borderRadius: '4px',
    padding: '1px 4px',
    marginLeft: 8,
    '@media (max-width: 1050px)': {
        marginLeft: 0,
        margin: '4px 0px',
    },
});

export const AccountOwner = styled('div')(({ theme }) => ({
    color: '#46536B',
    lineHeight: '14px',
    fontWeight: 500,
    '@media (max-width: 800px)': {
        fontSize: 12,
    },
}));

export const InvitationContent = styled('div')({
    display: 'flex',
    justifyContent: 'flex-end',
});

export const InvitationBody = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '0px 16px',
    maxWidth: 180,
});

export const GreyText = styled('div')(({ theme }) => ({
    color: theme.legacy.colors.neutralGrey75,
    paddingLeft: 8,
}));

export const SendButton = styled('div')(({ theme }) => ({
    fontSize: 14,
    lineHeight: '18px',
    color: theme.legacy.colors.primary,
    paddingTop: 2,
    paddingBottom: 0,
}));

export const PopoverPaper = styled(Paper)({
    width: 246,
    padding: '8px 0px',
    '& ul': {
        padding: 0,
        '& li': {
            padding: '11px 16px',
        },
    },
});
